/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { JSX } from 'react';

interface InputModeProps {
  type: string;
  icon?: JSX.Element;
  title: string;
  placeholder?: string;
  isRequired?: boolean;
  disabled?: boolean;
  isTextarea?: boolean;
  rows?: number;
  multiple?: boolean; // Only applies if type === 'file'
  handleInputChange?: any;
  inputName: string
  isShowError?: boolean
}

export const InputMode: React.FC<InputModeProps> = ({
  type,
  icon,
  title,
  placeholder,
  isRequired = true,
  disabled = false,
  isTextarea = false,
  rows = 4,
  multiple = false,
  handleInputChange,
  inputName,
  isShowError
}) => {
  return (
    <div className="w-full">
      <label className="block text-sm font-bold text-gray-800 mb-1">
        {title}
        {isRequired && <span className="text-red-500 ml-1">*</span>}
      </label>

      <div className="relative">
        {/* Show icon only if it's not a textarea */}
        {!isTextarea && icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
            {icon}
          </div>
        )}

        {isTextarea ? (
          <textarea
            onChange={(e: any) => handleInputChange(inputName, e.target.value)}
            rows={rows}
            placeholder={placeholder}
            disabled={disabled}
            className={`w-full pr-4 py-2.5 pl-4 border border-[#DFE4EA] rounded-md text-sm placeholder-gray-400 focus:outline-none resize-none
              ${disabled
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-white text-gray-700 focus:ring-1 focus:ring-[#3C51A0] focus:border-transparent'
              }`}
          />
        ) : (
          <>
            <input
              onChange={(e: any) => handleInputChange(inputName, e.target.value)}
              type={type}
              placeholder={placeholder}
              disabled={disabled}
              multiple={type === 'file' ? multiple : undefined}
              className={`lato-thin w-full ${icon ? 'pl-10' : 'pl-4'} pr-4 py-2.5 border border-[#DFE4EA] rounded-md text-sm placeholder-gray-400 focus:outline-none
              ${disabled
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-white text-gray-700 focus:ring-1 focus:ring-[#3C51A0] focus:border-transparent'
                }`}
            />
          </>
        )}
      </div>
      {isShowError && <p className='text-red-600 font-semibold pt-1 text-xs pl-1'>{title} is required</p>}

    </div>
  );
};
